module.exports = __webpack_public_path__ + "img/buying.2.8651f17.jpg";